import { Box } from '@pets-ui/Box/Box'
import { Container } from '@pets-ui/Container/Container'
import { HStack } from '@pets-ui/HStack/HStack'
import { Paper } from '@pets-ui/Paper/Paper'
import { zIndex } from '@pets-ui/tokens/zIndex.stylex'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'
import { HEADER_HEIGHT } from '../../constants'

const styles = stylex.create({
  root: {
    position: 'fixed',
    zIndex: zIndex.appBar,
    left: 0,
    right: 0,
    top: 0,
  },
})

interface AppBarProps {
  left?: ReactNode
  right?: ReactNode
}

export const AppBar = (props: AppBarProps) => {
  const { left, right } = props

  return (
    <>
      <Paper p={3} height={HEADER_HEIGHT} elevation={4} borderRadius={0} rootStyle={styles.root}>
        <Container height="100%">
          <HStack height="100%" justifyContent="space-between" alignItems="center" flexWrap="nowrap">
            {left}
            {right}
          </HStack>
        </Container>
      </Paper>
      <Box height={HEADER_HEIGHT} visibility="hidden" />
    </>
  )
}
